
import { createAsyncThunk } from "@reduxjs/toolkit";
import * as URL from "helpers/url_helper";
import { post } from "helpers/api_helper";

export const getDashboard = createAsyncThunk(
  "dashboard/getDashboard",
  async ({ callback }, { rejectWithValue }) => {
    try {
      const response = await post(URL.DASBOARDAPI);
      if (callback) callback(null, response);
      return response.data; 
    } catch (error) {
      if (callback) callback(error, null);
      return rejectWithValue(error.message);
    }
  }
);

